import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isApp } from '../bridge';
import { buildLocalePath } from '../utils/locale.utils';

export const useLocaleNavigate = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  return useCallback(
    (to, options) => {
      if (typeof to === 'number') {
        navigate(to);
        return;
      }

      if (isApp()) {
        navigate(to, options);
        return;
      }

      const prefixed = buildLocalePath(i18n.language, to);
      navigate(prefixed, options);
    },
    [navigate, i18n.language],
  );
};
